import { authService } from './authService';
import { getServerURL } from './config';

const SERVER_URL = getServerURL();

const buildAuthHeaders = (isJson = true) => {
  const headers = {};
  const token = authService.getToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (isJson) {
    headers['Content-Type'] = 'application/json';
    headers.Accept = 'application/json';
  }
  return headers;
};

export const generationImportService = {
  async getFonts({ activeOnly = true, script = '' } = {}) {
    const params = new URLSearchParams();
    if (activeOnly !== undefined) params.set('active_only', String(activeOnly));
    if (script) params.set('script', script);

    const response = await fetch(`${SERVER_URL}/generation-fonts${params.toString() ? `?${params.toString()}` : ''}`, {
      headers: buildAuthHeaders(true),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || `Failed to fetch fonts: ${response.status}`);
    }
    return data;
  },

  async uploadFont({ key, label, family, script = 'mixed', isDefault = false, files = {} }) {
    const formData = new FormData();
    formData.append('key', key);
    formData.append('label', label);
    formData.append('family', family);
    formData.append('script', script);
    formData.append('is_default', String(isDefault));

    if (files.regular) formData.append('regular', files.regular);
    if (files.italic) formData.append('italic', files.italic);
    if (files.bold) formData.append('bold', files.bold);
    if (files.bold_italic) formData.append('bold_italic', files.bold_italic);

    const response = await fetch(`${SERVER_URL}/generation-fonts/upload`, {
      method: 'POST',
      headers: buildAuthHeaders(false),
      body: formData,
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || `Failed to upload font: ${response.status}`);
    }
    return data;
  },

  async updateFont(id, updateData) {
    const response = await fetch(`${SERVER_URL}/generation-fonts/${id}`, {
      method: 'PATCH',
      headers: buildAuthHeaders(true),
      body: JSON.stringify(updateData),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || `Failed to update font: ${response.status}`);
    }
    return data;
  },

  async deleteFont(id) {
    const response = await fetch(`${SERVER_URL}/generation-fonts/${id}`, {
      method: 'DELETE',
      headers: buildAuthHeaders(true),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || `Failed to delete font: ${response.status}`);
    }
    return data;
  },

  async previewGoogleImport(payload) {
    const response = await fetch(`${SERVER_URL}/generation-stories/import/google/preview`, {
      method: 'POST',
      headers: buildAuthHeaders(true),
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || `Failed to preview import: ${response.status}`);
    }
    return data;
  },

  async executeGoogleImport(previewId) {
    const response = await fetch(`${SERVER_URL}/generation-stories/import/google/execute`, {
      method: 'POST',
      headers: buildAuthHeaders(true),
      body: JSON.stringify({ preview_id: previewId }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || `Failed to execute import: ${response.status}`);
    }
    return data;
  },

  async getImportJob(jobId) {
    const response = await fetch(`${SERVER_URL}/generation-stories/import/google/jobs/${jobId}`, {
      headers: buildAuthHeaders(true),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || `Failed to fetch import job: ${response.status}`);
    }
    return data;
  }
};
